import { em } from 'polished'
import styled from 'styled-components'

import DynamicImage from 'components/DynamicImage'
import CostContainerSale from 'containers/CostContainerSale'
import { BoxBase } from 'styles/components/layout'
import { H1Small } from 'styles/components/typography'

export const BoxBaseStyled = styled(BoxBase)`
  background: ${p => p.theme.colors.curiousBlue};
  color: ${p => p.theme.colors.white};
  padding-top: ${em(57)};
  padding-bottom: ${em(40)};

  ${p => p.theme.mq.upMd} {
    padding-top: ${em(47)};
    padding-bottom: ${em(58)};
  }

  ${p => p.theme.mq.upLg} {
    padding-top: ${em(40)};
    padding-bottom: ${em(40)};
  }
`

export const H1SmallStyled = styled(H1Small)`
  font-size: ${p => p.theme.typography.h2};
  line-height: ${p => p.theme.typography.h2Lh};

  ${p => p.theme.mq.upMd} {
    font-size: ${p => p.theme.typography.h1};
    line-height: ${p => p.theme.typography.h1Lh};
  }

  ${p => p.theme.mq.upLg} {
    font-size: ${p => p.theme.typography.h1MdSmall};
    line-height: ${p => p.theme.typography.h1LhMd};
  }
`

export const Wrapper = styled.div`
  position: relative;
  text-align: center;
  margin-top: ${em(68)};
  margin-bottom: ${em(50)};

  ${p => p.theme.mq.upMd} {
    margin-top: 0;
    margin-bottom: 0;
    height: 100%;
  }
`

export const DynamicImageStyled = styled(DynamicImage)`
  width: ${em(223)};
  height: auto;

  ${p => p.theme.mq.upMd} {
    position: absolute;
    width: ${em(400)};
    left: ${em(55)};
    top: 8%;
  }

  ${p => p.theme.mq.upLg} {
    position: relative;
    width: ${em(336)};
    left: 0;
    top: 0;
  }
`

export const CostWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  ${p => p.theme.mq.upMd} {
    justify-content: start;
    margin-top: ${em(40)};
  }

  ${p => p.theme.mq.upLg} {
    flex-direction: column;
    justify-content: center;
    marign-top: 0;
  }
`

export const CostContainerSaleStyled = styled(CostContainerSale)`
  margin-right: ${em(15)};

  ${p => p.theme.mq.upMd} {
    margin-right: ${em(27)};
  }

  ${p => p.theme.mq.upLg} {
    margin-right: 0;
    margin-bottom: ${em(20)};
  }
`
